// extracted by mini-css-extract-plugin
export default {"compChartView":"CompChart_compChartView__rgCkL","compChartWrapper":"CompChart_compChartWrapper__+ooQk"};